module.exports = "https://www.gc-qa.gnp.com.mx/29f8987a0a5ca69f917dc52d8a695047.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Banner_PortalSoyCliente-05.png
// module id = 8049
// module chunks = 0